export enum OnboardingStep {
  NotStarted = "notStarted",
  Completed = "Completed",
}
